export default __webpack_public_path__ + "locales/pt-BR/Files.json?hash=b0b1c2ad31210a2105a721b5647dede1";